/*A "slice" is a collection of Redux reducer logic and actions for a single feature in your app, 
typically defined together in a single file. The name comes from splitting up the root Redux state
 object into multiple "slices" of state. */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { type Eligibility } from '@/types/Eligibility';

import { RootState } from '../store';

export type EligibilityState = Nullable<Eligibility>;

type Nullable<T> = { [K in keyof T]: T[K] | null };
export const initialState: Nullable<Eligibility> = {
  id: null,
  dealId: null,
  customer: null,
  status: null,
  isEligible: null,
  lineItems: null,
  shippingCountries: null,
  shippingAddress: null,
  email: null,
  isRequestingSizingKit: null,
};

/* Reducers */
const eligibilitySlice = createSlice({
  name: 'eligibility',
  initialState,
  reducers: {
    initializeEligibility() {},

    updateLineItems(state, action: PayloadAction<Eligibility['lineItems']>) {
      state.lineItems = action.payload;
    },

    submittedShippingAddress(
      state,
      action: PayloadAction<{
        shippingAddress: Eligibility['shippingAddress'];
        email: Eligibility['email'];
      }>,
    ) {
      state.shippingAddress = action.payload.shippingAddress;
      state.email = action.payload.email;
    },

    submittedSizingKit(
      state,
      action: PayloadAction<Eligibility['isRequestingSizingKit']>,
    ) {
      state.isRequestingSizingKit = action.payload;
    },

    eligibilityAdded(_state, action: PayloadAction<Eligibility>) {
      return action.payload;
    },

    resetEligibility() {
      return initialState;
    },
  },
});

/* Actions */
export const {
  initializeEligibility,
  updateLineItems,
  eligibilityAdded,
  resetEligibility,
  submittedShippingAddress,
  submittedSizingKit,
} = eligibilitySlice.actions;

/* Selectors */
export const selectEligibility = (state: RootState) => state.eligibility;

export default eligibilitySlice.reducer;
